import { Injectable, Provider } from "@angular/core";
import { provideRoutes } from "@angular/router";
import { Observable, forkJoin, of } from "rxjs";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { catchError, map, switchMap, tap } from "rxjs/operators";
import { AuthType, IDENEDI_CODE_STORAGE_KEY} from "src/app/shared/services/auth.service";
import { IStemexeModule } from "../data-providers/interfaces/interfaces";
import { DataProvider, PagedData, PagedDataItem } from "../data-providers/models/models";
import { LocalEnum } from "../sellexe/shared/enums/localstorage";

//EspDataProviderService class and it's usage is only for demo purpose.
@Injectable({
  providedIn: "root"
})
export class OpporunityProDataProviderService implements IStemexeModule {
  type : AuthType= AuthType.OppPro;
  user :any = {};
  customerHeader = '';
  token = '';
  tannetURL = '';
  constructor(
    private http: HttpClient,
  ) {
    this.customerHeader = localStorage.getItem(LocalEnum.customHeader);
    this.token = localStorage.getItem(LocalEnum.token);
    this.tannetURL = localStorage.getItem(LocalEnum.url);
  }

  initialize(): void {
    this.user = localStorage.getItem(LocalEnum.user);
    // if(this.user){
      this.user = JSON.parse(this.user ? this.user : '[]');
    // }
  }

  getDataProviders(providerType: string): Observable<DataProvider[]> {
    let espDataProviders: DataProvider[] = [];
    let tannetURL = localStorage.getItem(LocalEnum.url);
    let user: any = localStorage.getItem(LocalEnum.user);
    user = JSON.parse(user ? user : '[]');
    if (providerType == 'ActivitySource') {
      let reqDataProvider: DataProvider = new DataProvider();
      reqDataProvider.title = 'Opportunity Pro';
      reqDataProvider.id = '3'; // see doc for more detail
      reqDataProvider.system = tannetURL;
      reqDataProvider.tenantId = user.organizationId + ""; // engpro oraginzation id
      reqDataProvider.getData = (token) => {
        return this._getProviderData(reqDataProvider, token)
      }
      espDataProviders.push(reqDataProvider);
    }
    return of(espDataProviders);
  }
  private _getProviderData(provider: DataProvider, nextPageToken?: any): Observable<PagedData> {
    console.log('token', nextPageToken)
    if(provider.id === '3'){

      let user: any = localStorage.getItem(LocalEnum.user);
      user = JSON.parse(user ? user : '[]');
      let tannetURL = localStorage.getItem(LocalEnum.url);
      return this.http.get(tannetURL + '/GetTerritories', this.getURLHeaders()).pipe(
        map((result: any) => {
          let pagedData = new PagedData();

          let opportunity = new PagedDataItem();
          opportunity.id = '1';
          opportunity.title = 'Opportunity',
          opportunity.url = '/pages/opportunity/';
          opportunity.getData = (token) => {
            return this._getOpportunities(token)
          }

          let customer = new PagedDataItem();
          customer.id = '2';
          customer.title = 'Customer',
          customer.url = '/pages/opportunity/';
          customer.extraData = {
            page: 1,
            search: '',
          }
          customer.getData = (token) => {
            return this._getCustomer(token, result.result)
          }

          let salesjob = new PagedDataItem();
          salesjob.id = '3';
          salesjob.title = 'SalesJob',
          salesjob.url = '/pages/opportunity/';
          salesjob.getData = (token) => {
            return this._getSaleJobs(token)
          }

          pagedData.items = [opportunity, customer, salesjob];
          return pagedData;
        })
      );
    }
    else{
      let pagedData = new PagedData();
      return of(pagedData);
    }
  }
  private _getOpportunities(nextPageToken?: any): Observable<PagedData> {
    console.log('token', nextPageToken)
    let user: any = localStorage.getItem(LocalEnum.user);
    user = JSON.parse(user ? user : '[]');
    let tannetURL = localStorage.getItem(LocalEnum.url);

    const data = {
      applicationUserId: user.applicationUserId,
      organizationId: user.organizationId,
      pageNo: 0,
      pageSize: 5000,
      searchPhrase: ""
    };
    return this.http.post(tannetURL + '/GetOpportunityListForActivitiesForStemexe', data, this.getURLHeaders()).pipe(
      map((result: any) => {
        let pagedData = new PagedData();
        pagedData.items = result.result.map((r: any) => {
          let item1 = new PagedDataItem();
          item1.id = r.opportunityId;
          item1.extraData = {
            customerId: r.customerId,
            customerName: r.customerName
          }
          item1.title = r.title,
          item1.url = '/pages/opportunity/'+r.opportunityId;
          item1.getData = (token) => {
            let pagedData = new PagedData();
            return of(pagedData);
          }
          return item1;
        })
        return pagedData;
      })
    );
  }
  private _getCustomer(nextPageToken: any, territories: any): Observable<PagedData> {
    console.log('token', nextPageToken)
    let user: any = localStorage.getItem(LocalEnum.user);
    user = JSON.parse(user ? user : '[]');
    let tannetURL = localStorage.getItem(LocalEnum.url);

    const data = {
      pageNo: nextPageToken?.page ? nextPageToken.page : 1,
      pageSize: 500,
      searchPhrase: nextPageToken?.extraData .search ? nextPageToken.extraData .search : "",
      territoryFilter: territories.map((obj: any) => obj.territoryId )
    };
    //GetCustomerList_Paging
    return this.http.post(tannetURL + '/SearchCustomerByFilter', data, this.getURLHeaders()).pipe(
      map((result: any) => {
        let pagedData = new PagedData();
        pagedData.items = result.result.map((r: any) => {
          let item1 = new PagedDataItem();
          item1.id = r.organizationId;
          item1.extraData = {
            page: data.pageNo,
            search: data.searchPhrase,
          }
          item1.title = r.organizationName,
          item1.url = '/pages/customer/'+r.organizationId;
          item1.getData = (token) => {
            let pagedData = new PagedData();
            return of(pagedData);
          }
          return item1;
        })
        return pagedData;
      })
    );
  }
  private _getSaleJobs(nextPageToken?: any): Observable<PagedData> {
    console.log('token', nextPageToken)
    let user: any = localStorage.getItem(LocalEnum.user);
    user = JSON.parse(user ? user : '[]');
    let tannetURL = localStorage.getItem(LocalEnum.url);
    return this.http.get(tannetURL + '/GetAllSalesJobListing', this.getURLHeaders()).pipe(
      map((result: any) => {
        let pagedData = new PagedData();
        pagedData.items = result.result.map((r: any) => {
          let item1 = new PagedDataItem();
          item1.id = r.salesJobId;
          item1.extraData = {}
          item1.title = r.salesJobTitle,
          item1.url = '/pages/salesjob/'+r.salesJobId;
          item1.getData = (token) => {
            let pagedData = new PagedData();
            return of(pagedData);
          }
          return item1;
        })
        return pagedData;
      })
    );
  }
  openUrl(url: string, context: any): any {
    if(url === '/pages/opportunity'){
      //asdf
    }
  }

  getURLHeaders(): any{
    return {
      headers: new HttpHeaders({
        Authorization:  'Bearer ' + localStorage.getItem(LocalEnum.token),
        customHeader:  localStorage.getItem(LocalEnum.customHeader)
      })
    }
  }
}